// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userMenuImage {
    height: 24px;
    width: 24px;
    border-radius: 50%;
}

.userMenuContent {
    min-width: 120px;
    padding: 8px;
}

.buttonDIV {
    justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/usermenu/usermenu.control.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".userMenuImage {\n    height: 24px;\n    width: 24px;\n    border-radius: 50%;\n}\n\n.userMenuContent {\n    min-width: 120px;\n    padding: 8px;\n}\n\n.buttonDIV {\n    justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
